export default {
	"subscribe.AccordingTo": "( according to",
	"subscribe.deduction": "deduction",
	"subscribe.Expect": "Expect )",
	"subscribe.PaymentTime": "Payment time:",
	"subscribe.OrderNumber": "Order number:",
	"subscribe.UnfortunatelyNoMatchingDataWasFound": "Unfortunately, no matching data was found",
	"subscribe.loadMore": "load more"
}